/**
 * Verbesserungen für Barrierefreiheit bei Elementor Karussells & Slidern
 * ...
 */

let initWpAccessibilitySliderFeatures;

if (typeof jQuery === 'undefined') {
    console.error('[WP Accessibility Sliders] jQuery wird benötigt, wurde aber nicht geladen.');
    initWpAccessibilitySliderFeatures = function() {
        console.error("[WP Accessibility Sliders] Initialisierung nicht möglich - jQuery fehlt.");
    };
} else {
    (function($) {
        'use strict';

        // --- Übersetzungen ---
        const i18nGlobal = (typeof WCO_UI_Translations !== 'undefined') ? WCO_UI_Translations : {};
        const i18nSlider = i18nGlobal.elementorSlider || {};

        // Labels
        const targetPrevLabel = i18nSlider.prevLabel || 'Show previous slide';
        const targetNextLabel = i18nSlider.nextLabel || 'Show next slide';
        const pauseButtonLabelPlaying = i18nSlider.pauseLabelPlaying || 'Pause slider';
        const pauseButtonLabelPaused  = i18nSlider.pauseLabelPaused  || 'Play slider';

        // Template für Slide-Zähler (z.B. "1 von 5")
        const slideLabelTemplate = i18nSlider.slideTemplate || '{current} of {total}';
        const slideLabelRegex = /^(\d+)\s*\/\s*(\d+)$/; // Erkennt das Elementor-Format "1 / 5"

        // Konfiguration und Selektoren
        const supportedWidgets = ['image-carousel', 'nested-carousel', 'slides'];
        const prevButtonSelector = '.elementor-swiper-button-prev';
        const nextButtonSelector = '.elementor-swiper-button-next';
        const slideSelector = '.swiper-slide';
        const swiperWrapperSelector = '.swiper-wrapper';

        // Play/Pause Konfiguration
        const playPauseTriggerClass = 'slider-pause';
        const playPauseButtonClass = 'swiper-button-pause';
        const controlsWrapperClass = 'slider-controls-wrapper';
        const playingClass = 'swiper-slider-playing';
        const pausedClass = 'swiper-slider-paused';
        const playIconSvg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" fill="currentColor" width="1em" height="1em"><path d="M48 432L336 256 48 80l0 352zM24.5 38.1C39.7 29.6 58.2 30 73 39L361 215c14.3 8.7 23 24.2 23 41s-8.7 32.2-23 41L73 473c-14.8 9.1-33.4 9.4-48.5 .9S0 449.4 0 432L0 80C0 62.6 9.4 46.6 24.5 38.1z"/></svg>';
        const pauseIconSvg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" fill="currentColor" width="1em" height="1em"><path d="M48 112l0 288 48 0 0-288-48 0zM0 112C0 85.5 21.5 64 48 64l48 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48L0 112zm224 0l0 288 48 0 0-288-48 0zm-48 0c0-26.5 21.5-48 48-48l48 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48l0-288z"/></svg>';

        // Aria-Live Konfiguration
        const ariaLiveTimeoutDuration = 2000;
        const ariaLiveTimeoutDataKey = 'aria-live-timeout';

        /**
         * Übersetzt die aria-label Attribute der Navigations-Buttons.
         * @param {jQuery} $scope Das jQuery-Objekt des Widget-Wrappers.
         */
        function translateNavButtonLabels($scope) {
            const $prevButton = $scope.find(prevButtonSelector);
            const $nextButton = $scope.find(nextButtonSelector);
            if ($prevButton.length) { $prevButton.attr('aria-label', targetPrevLabel); }
            if ($nextButton.length) { $nextButton.attr('aria-label', targetNextLabel); }
        }

        /**
         * Übersetzt die aria-label Attribute der einzelnen Slides ("X von Y").
         * @param {object} swiperInstance Die Swiper-Instanz.
         * @param {jQuery} $scope Das jQuery-Objekt des Widget-Wrappers.
         */
        function translateSlideLabels(swiperInstance, $scope) {
            if (!swiperInstance || !$scope) return;
            const $slides = $scope.find(slideSelector);
            $slides.each(function() {
                const $slide = $(this);
                const currentLabel = $slide.attr('aria-label');
                if (currentLabel && slideLabelRegex.test(currentLabel)) {
                    const matches = currentLabel.match(slideLabelRegex);
                    if (matches && matches.length === 3) {
                        // Nutzt das übersetzte Template aus PHP
                        const newLabel = slideLabelTemplate
                            .replace('{current}', matches[1])
                            .replace('{total}', matches[2]);

                        if ($slide.attr('aria-label') !== newLabel) {
                            $slide.attr('aria-label', newLabel);
                        }
                    }
                }
            });
        }

        /**
         * Setzt aria-live="polite" auf dem Swiper-Wrapper temporär nach Benutzerinteraktion.
         * @param {jQuery} $swiperWrapper Das jQuery-Objekt des Swiper-Wrappers.
         */
        function setAriaLivePoliteTemporarily($swiperWrapper) {
            if (!$swiperWrapper || !$swiperWrapper.length) return;
            const existingTimeout = $swiperWrapper.data(ariaLiveTimeoutDataKey);
            if (existingTimeout) { clearTimeout(existingTimeout); }
            $swiperWrapper.attr('aria-live', 'polite');
            const newTimeout = setTimeout(() => {
                const $pauseButton = $swiperWrapper.closest('.elementor-widget').find('.' + playPauseButtonClass);
                // Nur zurücksetzen, wenn nicht manuell pausiert
                if (!$pauseButton.length || $pauseButton.hasClass(playingClass)) {
                    $swiperWrapper.attr('aria-live', 'off');
                }
                $swiperWrapper.removeData(ariaLiveTimeoutDataKey);
            }, ariaLiveTimeoutDuration);
            $swiperWrapper.data(ariaLiveTimeoutDataKey, newTimeout);
        }

        /**
         * Fügt Klick-Listener zu Nav-Buttons hinzu, um aria-live temporär zu ändern.
         * @param {jQuery} $scope Das jQuery-Objekt des Widget-Wrappers.
         * @param {jQuery} $swiperWrapper Das jQuery-Objekt des Swiper-Wrappers.
         */
        function setupAriaLiveOnNavClick($scope, $swiperWrapper) {
            if (!$swiperWrapper || !$swiperWrapper.length) return;
            const $prevButton = $scope.find(prevButtonSelector);
            const $nextButton = $scope.find(nextButtonSelector);
            const handleClick = () => { setAriaLivePoliteTemporarily($swiperWrapper); };
            // Namespaced events
            if ($prevButton.length) { $prevButton.off('click.ariaLive').on('click.ariaLive', handleClick); }
            if ($nextButton.length) { $nextButton.off('click.ariaLive').on('click.ariaLive', handleClick); }
        }

        /**
         * Entfernt Elementors Hover-Autoplay-Steuerung für Widgets mit eigenem Play/Pause-Button.
         * @param {jQuery} $scope Das jQuery-Objekt des Widget-Wrappers.
         * @param {object} swiperInstance Die Swiper-Instanz.
         */
        function disableElementorPauseOnHover($scope, swiperInstance) {
            if (!$scope.hasClass(playPauseTriggerClass) || !swiperInstance || swiperInstance.destroyed || !swiperInstance.el) {
                return;
            }

            if (swiperInstance.params?.autoplay && typeof swiperInstance.params.autoplay === 'object') {
                swiperInstance.params.autoplay.pauseOnMouseEnter = false;
            }

            if (swiperInstance.originalParams?.autoplay && typeof swiperInstance.originalParams.autoplay === 'object') {
                swiperInstance.originalParams.autoplay.pauseOnMouseEnter = false;
            }

            $(swiperInstance.el).off('mouseenter mouseleave');
        }

        /**
         * Initialisiert Play/Pause-Button, Slide-Übersetzungen und Aria-Live-Management.
         * Wartet bei Bedarf auf die Swiper-Instanz.
         * @param {jQuery} $scope Das jQuery-Objekt des Widget-Wrappers.
         */
        function setupPlayPauseAndAria($scope) {
            // Robuster Swiper-Container-Selektor (für die initiale Suche)
            let $initialSwiperContainer = $scope.find('.elementor-main-swiper, .e-n-carousel.swiper, .elementor-image-carousel-wrapper, .swiper-container, .swiper').first();
            if (!$initialSwiperContainer.length) return; // Kein Swiper gefunden, Abbruch für dieses Widget

            // Finde Wrapper und richte Navigations-Klicks ein (falls Wrapper gefunden)
            const $swiperWrapper = $initialSwiperContainer.find(swiperWrapperSelector);
            if ($swiperWrapper.length) {
                setupAriaLiveOnNavClick($scope, $swiperWrapper);
            }

            const needsPlayPauseButton = $scope.hasClass(playPauseTriggerClass);

            // Funktion zur Initialisierung, sobald Swiper bereit ist
            function initializeSwiperDependentFeatures() {
                // Verwende den initial gefundenen Container, um die Instanz zu holen
                const swiperInstance = $initialSwiperContainer[0]?.swiper;
                const swiperReady = !!swiperInstance;
                // Prüfe Autoplay direkt auf der gefundenen Instanz
                const autoplayReady = swiperReady && !!swiperInstance.autoplay && typeof swiperInstance.autoplay.start === 'function';

                // Warten, falls Swiper noch nicht bereit ist (oder Autoplay fehlt, wenn benötigt)
                if (!swiperReady || (needsPlayPauseButton && !autoplayReady)) {
                    let retries = $scope.data('init-retries-swiper') || 0;
                    if (retries < 15) {
                        $scope.data('init-retries-swiper', retries + 1);
                        setTimeout(initializeSwiperDependentFeatures, 350 + (retries * 25));
                    }
                    return;
                }

                disableElementorPauseOnHover($scope, swiperInstance);

                // 1. Labels sofort übersetzen, um den ersten Ladezustand abzudecken.
                translateNavButtonLabels($scope);

                // 2. Die Übersetzungsfunktion an Swiper-Events binden.
                swiperInstance.off('init.translateNavLabels resize.translateNavLabels')
                    .on('init.translateNavLabels resize.translateNavLabels', () => {
                        translateNavButtonLabels($scope);
                    });


                // --- Swiper-abhängige Initialisierungen ---
                if ($swiperWrapper.length) {
                    // Slide Labels übersetzen (initial und bei Events)
                    translateSlideLabels(swiperInstance, $scope);
                    swiperInstance.off('slideChange.translateLabels').on('slideChange.translateLabels', () => translateSlideLabels(swiperInstance, $scope));
                    swiperInstance.off('resize.translateLabels').on('resize.translateLabels', () => translateSlideLabels(swiperInstance, $scope));
                    swiperInstance.off('reInit.translateLabels').on('reInit.translateLabels', () => translateSlideLabels(swiperInstance, $scope));

                    // Initiales aria-live setzen
                    $swiperWrapper.attr('aria-live', (swiperInstance.autoplay && swiperInstance.autoplay.running) ? 'off' : 'polite');
                }

                // Play/Pause Button hinzufügen
                if (needsPlayPauseButton && autoplayReady) {
                    if ($scope.find(`.${playPauseButtonClass}`).length) return; // Verhindert Duplikate
                    let swiperWrapperId = $swiperWrapper.attr('id');
                    if (!swiperWrapperId) { swiperWrapperId = 'swiper-wrapper-' + $scope.data('id') + '-' + Date.now(); $swiperWrapper.attr('id', swiperWrapperId); }
                    const isPlaying = swiperInstance.autoplay.running === true;
                    const widgetId = $scope.data('id') || 'slider';
                    const buttonId = `pause-button-${widgetId}-${Date.now()}`;

                    const $button = $('<button></button>')
                        .attr('id', buttonId)
                        .addClass(playPauseButtonClass)
                        .addClass(isPlaying ? playingClass : pausedClass)
                        .attr('aria-controls', swiperWrapperId)
                        .attr('aria-label', isPlaying ? pauseButtonLabelPlaying : pauseButtonLabelPaused)
                        .attr('aria-pressed', !isPlaying)
                        .html(isPlaying ? pauseIconSvg : playIconSvg);

                    $button.on('click', function() {
                        const $thisButton = $(this);
                        const $widget = $thisButton.closest('.elementor-widget');
                        // Finde den Swiper Container *innerhalb* dieses spezifischen Widgets neu
                        let $currentSwiperContainer = $widget.find('.elementor-main-swiper, .e-n-carousel.swiper, .elementor-image-carousel-wrapper, .swiper-container, .swiper').first();
                        if (!$currentSwiperContainer.length) { return; } // Kann Swiper nicht steuern
                        const currentSwiper = $currentSwiperContainer[0]?.swiper;
                        // Prüfe erneut, ob die Instanz und das Autoplay-Modul vorhanden sind
                        if (!currentSwiper || !currentSwiper.autoplay) { return; }
                        const $currentWrapper = $('#' + $thisButton.attr('aria-controls'));

                        if ($thisButton.hasClass(playingClass)) {
                            // Pausieren
                            currentSwiper.autoplay.stop();
                            $thisButton.removeClass(playingClass).addClass(pausedClass).attr({ 'aria-pressed': 'true', 'aria-label': pauseButtonLabelPaused }).html(playIconSvg);
                            if ($currentWrapper.length) $currentWrapper.attr('aria-live', 'polite');
                        } else {
                            // Abspielen
                            currentSwiper.autoplay.start();
                            $thisButton.removeClass(pausedClass).addClass(playingClass).attr({ 'aria-pressed': 'false', 'aria-label': pauseButtonLabelPlaying }).html(pauseIconSvg);
                            if ($currentWrapper.length) $currentWrapper.attr('aria-live', 'off');
                        }
                    });
                    // Controls Wrapper erstellen oder finden und Buttons einfügen/anordnen
                    let $controlsWrapper = $scope.find(`.${controlsWrapperClass}`);
                    if (!$controlsWrapper.length) { $controlsWrapper = $('<div></div>').addClass(controlsWrapperClass); $initialSwiperContainer.after($controlsWrapper); }
                    const $prevButton = $scope.find(prevButtonSelector);
                    const $nextButton = $scope.find(nextButtonSelector);
                    // Reihenfolge: Prev -> Pause -> Next
                    if ($prevButton.length) $controlsWrapper.append($prevButton);
                    $controlsWrapper.append($button);
                    if ($nextButton.length) $controlsWrapper.append($nextButton);
                }
            } // Ende initializeSwiperDependentFeatures

            // Starte die Initialisierung (wartet bei Bedarf auf Swiper)
            initializeSwiperDependentFeatures();
        }

        /**
         * Haupt-Handler für unterstützte Widgets.
         * @param {jQuery} $scope Das jQuery-Objekt des Widget-Wrappers.
         */
        function setupCarouselAccessibility($scope) {
            // Die Übersetzung wird nicht mehr hier aufgerufen. Sie wurde in die `initializeSwiperDependentFeatures`-Funktion verschoben,
            // um sie direkt an die Swiper-Events zu binden.
            setupPlayPauseAndAria($scope);
        }

        /**
         * Registriert die Elementor Frontend Hooks für die unterstützten Widgets.
         */
        initWpAccessibilitySliderFeatures = function() {
            $(window).off('elementor/frontend/init.wpAccSliders')
                .on('elementor/frontend/init.wpAccSliders', function () {
                    supportedWidgets.forEach(widgetName => {
                        elementorFrontend.hooks.addAction(`frontend/element_ready/${widgetName}.default`, setupCarouselAccessibility);
                    });
                });
        };

    }(jQuery));
}

// Export der Initialisierungsfunktion
export { initWpAccessibilitySliderFeatures };
